import { SVGProps } from "react";

export const ElevationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.9895 20.9898H2.07056L8.50513 12.0103H13.55V12.0162L13.5579 12.0064L20.9895 3.3287V20.9898ZM18.9924 8.69296L14.4456 13.9898H9.50024V13.982L9.49146 13.9937L5.94165 18.9937L5.92993 19.0103H19.01V8.67148L18.9924 8.69296ZM17.7356 3.82578L12.4456 9.98984H7.50024V9.98203L7.49146 9.99374L3.79712 15.1598L2.21411 14.0221L6.50513 8.01035H11.55V8.0162L11.5579 8.00644L16.2512 2.53964L17.7356 3.82578Z"
      fill="#C5C6C9"
      stroke="#C5C6C9"
      stroke-width="0.0208333"
    />
  </svg>
);
